
import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store/index.js';
import Home from "@/views/Home.vue";
import Layout from "@/views/tools/layout/Layout.vue";
import PrettyJsonRendererView from "@/views/Admin/PrettyJsonRendererView.vue";
import RolloverStagingView from "@/views/tools/rollover/RolloverStagingView.vue";
import PreviewResultsTableView from "@/views/tools/previews/PreviewResultsTableView.vue";
import TariffCodesView from "@/views/tools/tariffcodes/TariffCodesView.vue";
import TariffCodeDetailView from '@/views/tools/tariffcodes/TariffCodeDetailView.vue';
import EnrolledHealthSeekersView from '@/views/tools/tariffcodes/EnrolledHealthSeekersView.vue';
import SchemeListView from '@/views/tools/healthinsurances/SchemeListView.vue';
import SchemeDashboardView from '@/views/tools/healthinsurances/SchemeDashboardView.vue';
import SchemesTariffRatesDashboardView from "@/views/tools/healthinsurances/SchemesTariffRatesDashboardView.vue"
import SchemeTariffRatesDashboardView from '@/views/tools/healthinsurances/SchemeTariffRatesDashboardView.vue';
import SyncPracticesView from '@/views/tools/healthinsurances/SyncPracticesView.vue';
import TransactionsView from '@/views/tools/reporting/TransactionsView.vue';
import ReportTypesView from '@/views/tools/reporting/ReportTypesView.vue';


const routerHistory = createWebHistory();

const adminChildernRoutes = [
    {
        path: "",
        name: "scheme-list",
        component: SchemeListView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/programme-phases/:schemeId",
        name: "programmePhases",
        component: () => import("@/views/tools/adhoc/ProgrammeListView.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/health-insurances",
        name: "SchemeListView",
        component: SchemeListView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/schemes-tariff-rates",
        name: "SchemesTariffRatesDashboardView",
        component: SchemesTariffRatesDashboardView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/scheme-dashboard/:schemeId",
        name: "SchemeDashboardView",
        component: SchemeDashboardView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/scheme-tariff-rates-dashboard/:schemeId",
        name: "SchemeTariffRatesDashboardView",
        component: SchemeTariffRatesDashboardView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/scheme-healthseekers/:schemeId",
        name: "SchemeHealthseekers",
        component: () => import("@/views/tools/healthinsurances/SchemeHealthSeekerListView.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/sync-practices",
        name: "SyncPracticesView",
        component: () => import('@/views/tools/healthinsurances/SyncPracticesView.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/merge-home-based-tariff-codes",
        name: "MergeHBCTariffCodesView",
        component: () => import('@/views/tools/healthinsurances/MergeHBCTariffCodesView.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/sunset-tariff-codes",
        name: "SunsetTariffCodesView",
        component: () => import('@/views/tools/healthinsurances/SunsetTariffCodesView.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/upload-telephonic-codes",
        name: "UploadTelephonicCodesView",
        component: () => import('@/views/tools/healthinsurances/UploadTelephonicCodesView.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/update-allowed-qty",
        name: "UpdateAllowedQtyView",
        component: () => import('@/views/tools/healthinsurances/UpdateTariffCodesAllowedQtyView.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/report-types",
        name: "ReportTypesView",
        component: ReportTypesView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/transactions",
        name: "TransactionsView",
        component: TransactionsView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/tariff-codes",
        name: "TariffCodesView",
        component: TariffCodesView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/eligible-health-seekers",
        name: "EligibleHealthSeekersView",
        component: EnrolledHealthSeekersView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/tariff-code-detail",
        name: "TariffCodeDetailView",
        component: TariffCodeDetailView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/rollover-staging",
        name: "RolloverStaging",
        component: RolloverStagingView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/preview",
        name: "PreviewResultsTableView",
        component: PreviewResultsTableView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/treatment-plan",
        name: "TreatmentPlanView",
        component: () => import('@/views/tools/treatmentplans/TreatmentPlanView.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/pretty-json-renderer",
        name: "PrettyJsonRenderer",
        component: PrettyJsonRendererView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            requiresAuth: true
        }
    }
]

const routes = [
    // NEW LAYOUT (JUST IN MIND)
    {
        path: "/admin",
        name: "Layout",
        component: Layout,
        meta: {
            requiresAuth: true
        },
        children: adminChildernRoutes
    },
    // LEGACY LAYOUT 
    {
        path: "/login",
        name: "Login",
        component: () =>
            import ("@/views/Login/Login.vue"),
    },
    {
        path: "/forgot-password",
        name: "forgotPassword",
        component: () =>
            import ("@/views/Login/ForgotPassword.vue")
    },
    {
        path: "/recover-password",
        name: "recoverPassword",
        component: () =>
            import ("@/views/Login/RecoverPassword.vue")
    },
    {
        path: "/reset-password/:resetKey",
        name: "resetPassword",
        component: () =>
            import ("@/views/Login/ResetPassword.vue")
    },
    {
        path: "/clients",
        component: () =>
            import ("@/views/Client/ClientRoot.vue"),
        meta: {
            requiresAuth: true
        },
        children: [{
                path: "",
                component: () =>
                    import ("@/views/Client/NewClientList.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "add",
                name: "add-client",
                component: () =>
                    import ("@/views/Client/ClientAdd.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":id/edit",
                name: 'edit',
                component: () =>
                    import ("@/views/Client/ClientEdit.vue"),
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: ":id/add-case-record",
                name: 'add-case-record',
                component: () =>
                    import ("@/views/Client/Forms/ClientCaseRecordsAdd.vue"),
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: ":id/edit-case-record/:case_id",
                name: 'edit-case-record',
                component: () =>
                    import ("@/views/Client/Forms/ClientCaseRecordsEdit.vue"),
                meta: {
                    requiresAuth: true
                },
            },
        ]
    },
    {
        path: "/practitioners",
        component: () =>
            import ("@/views/Practitioner/PractitionerRoot.vue"),
        meta: {
            requiresAuth: true
        },
        children: [{
                path: "",
                name: "practitioner-list",
                component: () =>
                    import ("@/views/Practitioner/NewPractitionerList.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "add",
                name: "practitioner-add",
                component: () =>
                import ("@/views/Practitioner/PractitionerAdd.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":id/edit",
                name: "practitioner-edit",
                component: () =>
                import ("@/views/Practitioner/PractitionerEdit.vue"),
                meta: {
                    requiresAuth: true
                }
            },
        ]
    },
    {
        path: "/formulary",
        component: () =>
            import ("@/views/Formulary/FormularyList.vue"),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/formulary/:id/edit",
        name: "formulary-edit",
        component: () =>
        import ("@/views/Formulary/FormularyEdit.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/consumables",
        component: () =>
            import ("@/views/Formulary/Consumables.vue"),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/consumable/:id/edit",
        name: "consumable-edit",
        component: () =>
        import ("@/views/Formulary/ConsumablesEdit.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/resource-providers",
        component: () =>
            import ("@/views/Formulary/ResourceProvidersList.vue"),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/resource-providers/add",
        name: "resource-providers-add",
        component: () =>
            import ("@/views/Formulary/ResourceProvidersAdd.vue"),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/:id/edit",
        name: "resource-providers-edit",
        component: () =>
        import ("@/views/Formulary/ResourceProvidersEdit.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/clinical-alliances",
        component: () =>
            import ("@/views/ClinicalAlliance/ClinicalAllianceRoot.vue"),
        meta: {
            requiresAuth: true
        },
        children: [{
                path: "",
                component: () =>
                    import ("@/views/ClinicalAlliance/ClinicalAllianceList.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "add",
                name: "add-clinical-alliance",
                component: () =>
                    import ("@/views/ClinicalAlliance/ClinicalAllianceAdd.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":id/edit",
                name: 'clinical-alliance-edit',
                component: () =>
                    import ("@/views/ClinicalAlliance/ClinicalAllianceEdit.vue"),
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: ":id/add-case-record",
                name: 'add-case-record',
                component: () =>
                    import ("@/views/Client/Forms/ClientCaseRecordsAdd.vue"),
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: ":id/edit-case-record/:case_id",
                name: 'edit-case-record',
                component: () =>
                    import ("@/views/Client/Forms/ClientCaseRecordsEdit.vue"),
                meta: {
                    requiresAuth: true
                },
            },
        ]
    },
    {
        path: "/facilities",
        component: () =>
            import ("@/views/Facility/FacilityRoot.vue"),
        meta: {
            requiresAuth: true
        },
        children: [{
                path: "",
                component: () =>
                    import ("@/views/Facility/FacilityList.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "add",
                name: "add-facility",
                component: () =>
                    import ("@/views/Facility/FacilityAdd.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":id/edit",
                name: 'facility-edit',
                component: () =>
                    import ("@/views/Facility/FacilityEdit.vue"),
                meta: {
                    requiresAuth: true
                },
            },
        ]
    },
    {
        path: "/funding-options",
        component: () =>
            import ("@/views/Admin/FundingOptionRoot.vue"),
        meta: {
            requiresAuth: true
        },
        children: [{
                path: "",
                component: () =>
                    import ("@/views/Admin/FundingOptionList.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "add",
                name: "funding-option-add",
                component: () =>
                    import ("@/views/Admin/FundingOptionAdd.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: ":id/edit",
                name: 'funding-option-edit',
                component: () =>
                    import ("@/views/Admin/FundingOptionEdit.vue"),
                meta: {
                    requiresAuth: true
                },
            },
        ]
    },
];

const router = createRouter({
    history: routerHistory,
    routes: routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters['login/isLoggedIn']) {
            next()
            return
        }
        next('/login')
    } else {
        next()
    }
})

export default router;